import React from "react";
import { WidgetProps } from "@rjsf/utils";
import { Checkbox } from "antd";

interface EnumOptionsType {
  value: string | number;
  label: string;
}

const CheckboxesWidget = (props: WidgetProps) => {
  const {
    id,
    value,
    disabled,
    readonly,
    options,
    onChange,
    onBlur,
    onFocus,
  } = props;

  const enumOptions = (options?.enumOptions || []) as EnumOptionsType[];

  const currentValue: (string | number)[] = Array.isArray(value) ? value : [];

  return (
    <div id={id} onBlur={() => onBlur(id, value)} onFocus={() => onFocus(id, value)}>
      <Checkbox.Group
        value={currentValue}
        disabled={disabled || readonly}
        onChange={(checkedValues) => onChange(checkedValues)}
        className="flex flex-col gap-2"
      >
        {enumOptions.map((option) => (
          <Checkbox key={String(option.value)} value={option.value}>
            {option.label}
          </Checkbox>
        ))}
      </Checkbox.Group>
    </div>
  );
};

export default CheckboxesWidget;
